export const ASSET_CODE = {
  CASH: "cash",
  BILLS: "bills",
  STB: "stb",
  ITB: "itb",
  LTB: "ltb",
  COMMODITIES: "commodities",
  GOLD: "gold",
  REITS: "reits",
  TSM: "tsm",
  DLCB: "dlcb",
  DLCG: "dlcg",
  DLCV: "dlcv",
  DMCB: "dmcb",
  DMCG: "dmcg",
  DMCV: "dmcv",
  DSCG: "dscg",
  DSCB: "dscb",
  DSCV: "dscv",
  ILCB: "ilcb",
  ILCG: "ilcg",
  ILCV: "ilcv",
  IMCB: "imcb",
  IMCG: "imcg",
  IMCV: "imcv",
  ISCB: "iscb",
  ISCG: "iscg",
  ISCV: "iscv",
};

export const ASSET_DESCRIPTION = {
  CASH: "Cash/Money Market",
  BILLS: "Fixed Income: Bills (1 YR or Less)",
  STB: "Fixed Income: Short Term Bonds (1 - 3 YRS)",
  ITB: "Fixed Income: Intermediate Term Bonds (3 - 15 YRS)",
  LTB: "Fixed Income: Long Term Bonds (15 - 30 YRS)",
  COMMODITIES: "Real Assets: Commodoties",
  GOLD: "Real Assets: Gold",
  REITS: "Real Assets: Real Estate Invesment Trusts (REITs)",
  TSM: "Equities: Total Stock Market (TSM)",
  DLCB: "Equities: Domestic Large Cap Blend (DLCB)",
  DLCG: "Equities: Domestic Large Cap Growth (DLCG)",
  DLCV: "Equities: Domestic Large Cap Value (DLCV)",
  DMCB: "Equities: Domestic Medium Cap Blend (DMCB)",
  DMCG: "Equities: Domestic Medium Cap Growth (DMCG)",
  DMCV: "Equities: Domestic Medium Cap Value (DMCV)",
  DSCG: "Equities: Domestic Small Cap Growth (DSCG)",
  DSCB: "Equities: Domestic Small Cap Blend (DSCB)",
  DSCV: "Equities: Domestic Small Cap Value (DSCV)",
  ILCB: "Equities: International Large Cap Blend (ILCB)",
  ILCG: "Equities: International Large Cap Growth (ILCG)",
  ILCV: "Equities: International Large Cap Value (ILCV)",
  IMCB: "Equities: International Medium Cap Blend (IMCB)",
  IMCG: "Equities: International Medium Cap Growth (IMCG)",
  IMCV: "Equities: International Medium Cap Value (IMCV)",
  ISCB: "Equities: International Small Cap Blend (ISCB)",
  ISCG: "Equities: International Small Cap Growth (ISCG)",
  ISCV: "Equities: International Small Cap Value (ISCV)",
};

export const ASSET_TYPE = [
  `${ASSET_CODE.CASH} ${ASSET_DESCRIPTION.CASH}`,
  `${ASSET_CODE.BILLS} ${ASSET_DESCRIPTION.BILLS}`,
  `${ASSET_CODE.STB} ${ASSET_DESCRIPTION.STB}`,
  `${ASSET_CODE.ITB} ${ASSET_DESCRIPTION.ITB}`,
  `${ASSET_CODE.LTB} ${ASSET_DESCRIPTION.LTB}`,
  `${ASSET_CODE.COMMODITIES} ${ASSET_DESCRIPTION.COMMODITIES}`,
  `${ASSET_CODE.GOLD} ${ASSET_DESCRIPTION.GOLD}`,
  `${ASSET_CODE.REITS} ${ASSET_DESCRIPTION.REITS}`,
  `${ASSET_CODE.TSM} ${ASSET_DESCRIPTION.TSM}`,
  `${ASSET_CODE.DLCB} ${ASSET_DESCRIPTION.DLCB}`,
  `${ASSET_CODE.DLCG} ${ASSET_DESCRIPTION.DLCG}`,
  `${ASSET_CODE.DLCV} ${ASSET_DESCRIPTION.DLCV}`,
  `${ASSET_CODE.DMCB} ${ASSET_DESCRIPTION.DMCB}`,
  `${ASSET_CODE.DMCG} ${ASSET_DESCRIPTION.DMCG}`,
  `${ASSET_CODE.DMCV} ${ASSET_DESCRIPTION.DMCV}`,
  `${ASSET_CODE.DSCB} ${ASSET_DESCRIPTION.DSCB}`,
  `${ASSET_CODE.DSCG} ${ASSET_DESCRIPTION.DSCG}`,
  `${ASSET_CODE.DSCV} ${ASSET_DESCRIPTION.DSCV}`,
  `${ASSET_CODE.ILCB} ${ASSET_DESCRIPTION.ILCB}`,
  `${ASSET_CODE.ILCG} ${ASSET_DESCRIPTION.ILCG}`,
  `${ASSET_CODE.ILCV} ${ASSET_DESCRIPTION.ILCV}`,
  `${ASSET_CODE.IMCB} ${ASSET_DESCRIPTION.IMCB}`,
  `${ASSET_CODE.IMCG} ${ASSET_DESCRIPTION.IMCG}`,
  `${ASSET_CODE.IMCV} ${ASSET_DESCRIPTION.IMCV}`,
  `${ASSET_CODE.ISCB} ${ASSET_DESCRIPTION.ISCB}`,
  `${ASSET_CODE.ISCG} ${ASSET_DESCRIPTION.ISCG}`,
  `${ASSET_CODE.ISCV} ${ASSET_DESCRIPTION.ISCV}`,
];
